import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

export const uploadMediaFile = (file: any) => {
  const dispatch = useDispatch();
  const platformEnabled = useSelector(
    (state: RootState) => state.lomavisCreator.platformEnabled
  );
  const postTypeSelected = useSelector(
    (state: RootState) => state.lomavisCreator.postTypeSelected
  );

  // get cloudinary token
  // upload
  // set process
  // if does not work -> show toastr, remove uploading file from list
  // if works -> update file to uploaded
  // while uploading -> block additional file uploads + reordering
};

export function relocatePublishButtons({ footerRef, setRightMargin }) {
  let buttonsContainer = document.getElementById("publishButtons");
  const feedbackButton =
    document.getElementsByClassName("bb-feedback-button")[0];
  if (!feedbackButton) return;
  let feedbackButtonRect = feedbackButton.getBoundingClientRect();

  const footerElement = footerRef.current;

  if (!footerElement) return;

  let footerRect = footerElement?.getBoundingClientRect();
  let footerX = footerRect["x"];
  let footerWidth = footerRect["width"];

  let feedbackButtonOverlay = footerX + footerWidth - feedbackButtonRect["x"];
  let newMargin = Math.max(10 + feedbackButtonOverlay, 0);
  setRightMargin(newMargin);
  if (buttonsContainer) {
    buttonsContainer.style.marginRight = newMargin + "px";
  }
}
